// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"4a9ec049","387":"082331a5","722":"68a384e9"}[chunkId] + ".chunk.css";
};